import './style.scss'

import { UniversalNotice } from '@skillbox/promo-banner/dist/UniversalNotice/scripts.js'
import { showOrderModal } from '../../popups/v1/OrderModal/scripts'
import { saleEndDate } from '../../../js/components/SaleEndDate/SaleEndDate'

export default !async function () {
  const block = document.querySelector('.universal-notice-wrapper')

  if (!block) {
    return
  }

  const clickBannerHandler = (evt) => {
    evt.preventDefault()

    const blockName = block.closest('[data-block-name]')?.dataset.blockName ?? 'Блок без названия'

    showOrderModal({
      isCenter: false,
      hiddenFields: [{ name: 'type', value: 'event' }],
      blockName
    })

    !isGbHost && window.$analytics?.push('fl-show-form') // eslint-disable-line
    window.$analytics?.push('all-block-learn-more-click', { blockName })
  }

  const promoBanner = new UniversalNotice({ onClick: clickBannerHandler })
  saleEndDate.addObserver(time => promoBanner.setTimer(time))
}()
